import React, {useEffect, useState} from 'react';
import {Link, useHistory, useLocation, useParams} from 'react-router-dom';
import BackBtn from '../../../RiskComponents/pageHeader/img/arrow-left.svg';
import {t} from 'react-switch-lang';
import Dropdown from '../../../../components/droppdown/dropdown';
import ListNav from '../../../../components/tabsNav/Tabs';
import EditFindingsForm from '../findingsForm/EditFindingsForm';
import {deleteFinding, getSingleFinding} from '../../../../services/findings';
import TransitionModal from '../../../../components/preventTransitionprompt/TransitionModal';
import PreventTransitionPrompt from '../../../../components/preventTransitionprompt/PreventTransition';
import Prompt from '../../../../components/prompt/prompt';
import Toast from '../../../../components/toast/Toast';
import Swal from 'sweetalert2';
import roles from '../../../../utils/roles';
import {useUserContext} from '../../../../contexts/UserContext';
import FindingsRemarks from '../findingsRemarks/FindingsRemarks';
import FindingTrail from '../findingTrail/FindingTrail';

const FindingDetails = () => {
  const [activeTab, setActiveTab] = useState('finding-detail');
  const history = useHistory();
  const [editIsDisabled, setEditIsDisabled] = useState(true);
  const [allowCRUD, setAllowCRUD] = useState(false);
  const [allowEdit, setAllowEdit] = useState(false);
  const [refresh, setRefresh] = useState(true)
  const [transitionModal, setTransitionModal] = useState(false);
  const [findingData, setFindingData] = useState();
  const [tempTab, setTempTab] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const params = useParams();
  const {state} = useLocation();
  const user = useUserContext();
  const fetch = async () => {
    const response = await getSingleFinding(params?.findingId);
    setFindingData(response);
  };

  useEffect(() => {
    fetch();
  }, [params.findingId, editIsDisabled, activeTab === 'finding-details']);

  useEffect(() => {
    if (state?.isEditing) {
      setEditIsDisabled(false);
    }
  }, [state]);

  const revisionRoles = [
    roles.role_internal_auditor,
    roles.role_head_of_internal_audit,
    roles.role_super_admin,
    roles.role_admin
  ];
  const allowedRoles = [
    roles.role_super_admin,
    roles.role_admin
  ];

  useEffect(() => {
    const result = allowedRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowEdit(result.length > 0);
  }, [user]);

  useEffect(() => {
    const result = revisionRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowCRUD(result.length > 0);
  }, [user]);
  const findingStatus = ((findingData?.data?.findingStatus === 'ABORTED') || (findingData?.data?.findingStatus === 'COMPLETED') ) ? allowEdit : allowCRUD
  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === 'POP') {
        history.push(`/revisions/${params?.revisionId}/findings`);
        return false;
      }
    });

    return () => unblock();
  }, []);
  return (
    <div>
      <TransitionModal
        open={transitionModal}
        toggleModal={() => setTransitionModal(!transitionModal)}
        onCancel={() => setTransitionModal(false)}
        onOk={() => {
          setEditIsDisabled(true);
          setTransitionModal(false);
          setActiveTab(tempTab);
        }}
      />
      <PreventTransitionPrompt when={!editIsDisabled} />
      <div className="container-fluid controls d-flex align-items-center justify-content-end">
        <Link
          to={`/revisions/${params?.revisionId}/findings`}
          className="return-btn-revisions d-flex "
        >
          <img src={BackBtn} alt="icon" />
          <span>
            {t('revisions.finding')} : {findingData?.data?.name}
          </span>
        </Link>
        {findingStatus && <div className="row">
          <div className="col-12 d-flex justify-content-end">
            {editIsDisabled ? (
              <div>
                <button
                  disabled={isLoading}
                  className="primary-btn mr-3 cursor-pointer"
                  onClick={(event) => {
                    event.preventDefault();
                    setActiveTab('finding-detail');
                    setEditIsDisabled(false);
                  }}
                >
                  {t('common.edit')}
                </button>
              </div>
            ) : null}

            {editIsDisabled && allowCRUD && (
              <Dropdown
                buttonClass="options-btn"
                trigger={
                  <img src={process.env.PUBLIC_URL + '/images/dots.svg'} />
                }
                children={
                  <>
                    <li
                      onClick={async () => {
                        setIsLoading(true);
                        await Prompt.fire({
                          title: t('title.deleteFinding'),
                          text: t('question.deleteFinding'),
                          confirmButtonText: t('common.confirm'),
                          cancelButtonText: t('common.cancel'),
                          preConfirm: async () => {
                            try {
                              const response = await deleteFinding(
                                params?.findingId
                              );
                              if (response.status === 204) {
                                Toast.fire({
                                  title: t('message.deleteSuccess2', {
                                    entity: t('revisions.finding'),
                                  }),
                                  icon: 'success',
                                });
                                setTimeout(() => {
                                  history.go(-1);
                                }, 1000);
                              } else {
                                Swal.fire({
                                  text: t('Pages.messages.deleteError'),
                                  icon: 'error',
                                });
                              }
                            } catch (err) {
                              Swal.fire({
                                text: t('Pages.messages.deleteError'),
                                icon: 'error',
                              });
                            }
                          },
                        });
                        setIsLoading(false);
                      }}
                    >
                      {t('common.delete')}
                    </li>
                  </>
                }
              ></Dropdown>
            )}
          </div>
        </div>}
      </div>

      <ListNav
        items={[
          {name: t('sidebar.findingDetails'), target: 'finding-detail'},
          {name: t('revisions.responses'), target: 'finding-response'},
          {name: t('sidebar.revisionTrail'), target: 'finding-audit'},
        ]}
        textProperty="name"
        itemValue="target"
        selectedItem={activeTab}
        onItemSelect={(e) => {
          if (!editIsDisabled && e !== 'finding-detail') {
            setTransitionModal(true);
            setTempTab(e);
          } else {
            fetch()
            setActiveTab(e);
          }
        }}
        classes="tabs-nav  pl-0"
      />
      <div className={'revisions-tabs-content'}>
        {activeTab === 'finding-detail' && (
          <>
            <EditFindingsForm
              editIsDisabled={editIsDisabled}
              setEditIsDisabled={setEditIsDisabled}
              data={findingData}
            />
          </>
        )}
        {activeTab === 'finding-response' && (
          <FindingsRemarks findingData={findingData} />
        )}
        {activeTab === 'finding-audit' && <FindingTrail />}
      </div>
    </div>
  );
};

export default FindingDetails;
